import { useDeliveryApi } from 'infrastructure/api';
import staffingNoteValidation from './staffingNoteValidation';

const useStaffingNotesService = () => {
  const { sendPostRequest, sendPutRequest } = useDeliveryApi();

  const createStaffingNote = async (projectId: string, command: { noteText: string; attachmentPaths?: string[] }) => {
    const response = await sendPostRequest(`/projects/${projectId}/staffing-notes`, {
      noteText: command.noteText,
      attachmentPaths: command.attachmentPaths || [],
    });

    return response.json();
  };

  const updateStaffingNote = async (id: string, command: { noteText: string; attachmentPaths?: string[] }) => {
    const response = await sendPutRequest(`/projects/staffing-notes/${id}`, {
      noteText: command.noteText,
      attachmentPaths: command.attachmentPaths || [],
    });

    return response.json();
  };

  return {
    getValidationSchema: () => Promise.resolve(staffingNoteValidation),
    createStaffingNote,
    updateStaffingNote,
  };
};

export default useStaffingNotesService;
